import { Fragment } from 'react'
import { RELEASE_NOTES_CONTENTS } from '../constants'

export const ReleaseNotesContainer = (): React.ReactElement => {
  return (
    <div
      css={{
        display: 'grid',
        rowGap: '16px',
        marginTop: '16px',

        '.list-heading': {
          fontWeight: 500,
          fontSize: '20px',
          marginTop: '12px',
        },
        '.flex-heading': {
          display: 'flex',
          alignItems: 'center',
          '> *:last-child': {
            marginLeft: '8px',
          },
        },
      }}
    >
      {RELEASE_NOTES_CONTENTS.map((content) => (
        <div
          key={content.version}
          css={(theme) => ({
            padding: '24px',
            borderRadius: '8px',
            backgroundColor: theme.colors.primary[50],
          })}
        >
          <div
            className="flex-heading"
            css={(theme) => ({
              fontWeight: 500,
              fontSize: '20px',
              color: theme.colors.primary[400],
            })}
          >
            <p>Release Version:</p>
            <p>{content.version}</p>
          </div>
          <div className="flex-heading">
            <p css={{ fontWeight: 500 }}>Release Date:</p>
            <p css={{ fontWeight: 300 }}>{content.releasedDate}</p>
          </div>

          <h3 className="list-heading">Feature Updates</h3>
          <ul
            css={{
              paddingLeft: '24px',
            }}
          >
            {content.features.map((feat, idx) => {
              const { contents, title } = feat

              return (
                <li
                  key={idx}
                  css={{
                    '&:not(:first-of-type)': {
                      marginTop: '12px',
                    },
                  }}
                >
                  {title}

                  {contents && (
                    <ul
                      css={{
                        marginTop: '4px',
                        paddingLeft: '40px',
                        listStyleType: 'circle',
                        listStylePosition: 'outside',
                      }}
                    >
                      {contents.map((content) => (
                        <li
                          key={content}
                          css={{
                            wordWrap: 'break-word',
                          }}
                        >
                          {content}
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              )
            })}
          </ul>

          {content.bugs && (
            <Fragment>
              <h3 className="list-heading">Bugs Fixed</h3>
              <ul
                css={{
                  pl: {
                    base: 6,
                  },
                }}
              >
                {content.bugs.map((bug, idx) => (
                  <li key={idx}>{bug}</li>
                ))}
              </ul>
            </Fragment>
          )}
        </div>
      ))}
    </div>
  )
}
